import { isDescendantOf } from '../../ui_utils/PixiUtils.ts';
export class UIGameToolTipController {
    tipHasParent() {
        if (this.tip == null) return false;
        if (this.tip.parent == undefined) return false;
        return true;
    }
    disableTip(view) {
        view.interactive = false;
        if (this.tip == null) return;
        if (!isDescendantOf(this.tip, view)) return;
        this.closeTip();
    }
    closeTip() {
        if (!this.tipHasParent() || this.tip == null) return;
        this.tip.parent.removeChild(this.tip);
        this.tip = null;
    }
    constructor(uiGameManager){
        this.tip = null;
        this.app = uiGameManager.canvasController.app;
    }
}
